import * as packageInfo from '../../package.json';

export const environment = {
  production: true,
  fbAppId: '399035711357359',
  name: 'prod',
  iosTtsEndpoint: 'https://9hyosyun3c.execute-api.us-east-1.amazonaws.com/ios',
  androidTtsEndpoint: 'https://tx78ddnag3.execute-api.us-east-1.amazonaws.com/android', // prod (>= version 2.0)
  iosTtsPremEndpoint: 'https://ahyzgnryje.execute-api.us-east-1.amazonaws.com/prod-ipm',
  iosTtsPlusEndpoint: 'https://o0q2iu5f11.execute-api.us-east-1.amazonaws.com/prod-ips',
  androidTtsPremEndpoint: 'https://6gky178ne5.execute-api.us-east-1.amazonaws.com/prod-apm',
  androidTtsPlusEndpoint: 'https://8bu6m35w24.execute-api.us-east-1.amazonaws.com/prod-aps',

  // ttsEndpoint: 'https://tuwz0i1tl0.execute-api.us-east-1.amazonaws.com/prod',
  ttsEndpoint: 'https://68eef54uob.execute-api.us-east-1.amazonaws.com/prod', // started from 220225
  tts2022PremEndpoint: 'https://moxu0s1jnk.execute-api.us-east-1.amazonaws.com/prod-wpm',
  tts2022PlusEndpoint: 'https://2poo4vxwjc.execute-api.us-east-1.amazonaws.com/prod-wps',
  // tts2022PlusEndpoint: 'https://8chj6t4ppj.execute-api.us-east-1.amazonaws.com/dev',
  // convertEndpoint: 'https://pw-convert.naturalreaders.com',
  convertEndpoint: 'https://pw-mp3.naturalreaders.com', // started from 220225
  convertToAudioPath: '/convert-to-audio',

  pwAudioManagement: 'https://7m2x5s0hv2.execute-api.us-east-1.amazonaws.com/Dev',
  pwAudioEndpoint: 'https://qf5ybqnz0l.execute-api.us-east-1.amazonaws.com/prod',
  iOSAudioManagement: 'https://f3q4lotpaa.execute-api.us-east-1.amazonaws.com/ios',
  pwUserInfo: 'https://7t9wl31rh3.execute-api.us-east-1.amazonaws.com/Prod',

  purchaseEndpoint: 'https://o40dlv9xk8.execute-api.us-east-1.amazonaws.com/prod',
  paymentEndpoint: 'https://ransxfmm6c.execute-api.us-east-1.amazonaws.com/Prod',
  billEndpoint: 'https://rrauikxmbg.execute-api.us-east-1.amazonaws.com/prod',
  commBillEndpoint: 'https://7mtv4xe7ga.execute-api.us-east-1.amazonaws.com/prod/',
  stripeKey: 'pk_live_abKS4TA7uF0ONEKUHEtYPMvp',
  mobileEndpoint: 'https://da57h8vqvi.execute-api.us-east-1.amazonaws.com/Prod',
  ssoLoginEndpoint: 'https://www.naturalreaders.com/login-service/login?',
  ssoSignupEndpoint: 'https://www.naturalreaders.com/login-service/signup?',
  webApiDomain: 'https://webapi.naturalreaders.com/prod',
  eduEndpoint: 'https://1pakmhwu39.execute-api.us-east-1.amazonaws.com/prod', // old-prod
  // eduEndpoint: 'https://fxiv5c2c9j.execute-api.us-east-1.amazonaws.com/prod', // edu-2022-prod
  chromeExtensionId: 'kohfgcgbkjodfcfkcackpagifgbcmimk',
  ssoApi: 'https://6258ykb3q1.execute-api.us-east-1.amazonaws.com/prod',
  issueApi:'https://zbmbj9907e.execute-api.us-east-1.amazonaws.com/prod',

  appCheckVersionEndpoint: 'https://5w0xq4hntl.execute-api.us-east-1.amazonaws.com/Prod',
  uploadOcrDomain: 'https://uploadocr.naturalreaders.com',
  fileSharingEndpoint: 'https://p1my8wsitf.execute-api.us-east-1.amazonaws.com/prod',

  pdfTaggingEndpoint: 'https://1sltenn359.execute-api.us-east-1.amazonaws.com/prod',
  extendedApiEndpoint: 'https://sgglax06i9.execute-api.us-east-1.amazonaws.com/prod',
  docConvertEndpoint: 'https://dc.naturalreaders.com/convert-to-pdf',
  jsonToPdfEndpoint: 'jsontopdf',
  pdfUploadEndpoint: 'https://2hi0jl755g.execute-api.us-east-1.amazonaws.com/default/lambda-upload-pdf',
  imageOCREndpoint: 'https://ocr.naturalreaders.com/multi-image-prod', //new ai ocr
  pdfOCREndpoint: 'https://ocr.naturalreaders.com/pdf-prod', //new ai ocr test
  chatGptWssEndpoint: 'wss://fhovxjzqnl.execute-api.us-east-1.amazonaws.com/prod',
  pdfLayoutEndpoint: 'https://110d8g1ccb.execute-api.us-east-1.amazonaws.com/prod',
  chatPdfEndpoint: 'https://fngqqy3sa7.execute-api.us-east-1.amazonaws.com/prod',
  annotationApi: 'https://5e51eg17q0.execute-api.us-east-1.amazonaws.com/default/pw-annotation-manage',
  hffPredictEndpoint: 'https://268lxldhzk.execute-api.us-east-1.amazonaws.com/prod',
  voiceCloningEndpoint: 'https://iies50erj2.execute-api.us-east-1.amazonaws.com/prod',
  userRecordingEndpoint: 'https://7cz969ayl3.execute-api.us-east-1.amazonaws.com/prod',
  audioEndpoint: 'https://audio.naturalreaders.com',
  packageInfo
};
